import { Typography } from './';
import React from 'react';
import styled from 'styled-components';

const AboutWrapper = styled.div`
  padding: 0;
  margin: 0;
  padding-bottom: 15px;
`;

const AboutItem = props => {
  const { title, position, timeline } = props;
  return (
    <AboutWrapper>
        <Typography variant="p" color="blue" transform={props.upper ? 'uppercase  ' : 'initial'}>{title}</Typography>
        {position ? <Typography fontSize="16" variant="p">{position}</Typography> : null}
        {timeline ? <Typography fontSize="15" variant="p">{timeline}</Typography> : null}
    </AboutWrapper>
  )
}

export { AboutItem };